import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=dcfebdc0&scoped=true&"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js&"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=dcfebdc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfebdc0",
  null
  
)

export default component.exports